export const keyboardNavigation = (event, keyName, action, withAlt) => {
  const isKeyMatch = event.key.toLowerCase() === keyName.toLowerCase();
  const altPressed = withAlt ?? false;

  if (altPressed) {
    if (isKeyMatch && event.altKey) {
      action();
    }
  } else if (isKeyMatch) {
    action();
  }
};
